var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitchAndReplace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1501 13.7356C25.346 13.7356 12.519 26.5473 12.519 42.3666H8.54785C8.54785 24.3527 23.1542 9.7644 41.1501 9.7644H61.2001V13.7356H41.1501Z",
    fill: "#16104F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2995 12.9L60.3662 5V20.8L68.2995 12.9Z",
    fill: "#16104F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6837 66.1478C53.4878 66.1478 66.3148 53.3361 66.3148 37.5167H70.286C70.286 55.5307 55.6796 70.119 37.6837 70.119H17.6504V66.1478H37.6837Z",
    fill: "#16104F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5332 66.9834L18.4665 74.8834V59.0834L10.5332 66.9834Z",
    fill: "#170F4F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5001 57.35H29.2334V23.0834H50.6334V57.35H46.3667",
    fill: "#00BAC7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.248 21.0978H52.6192V59.3356H46.367V55.3644H48.648V25.0689H31.2192V55.3644H33.5003V59.3356H27.248V21.0978Z",
    fill: "#16104F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2497 55.9189H37.833V51.9478H42.2497V55.9189Z",
    fill: "#16104F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchAndReplace);
export default __webpack_public_path__ + "static/media/switch-and-replace.fc6081be5d2d4b60fb11f4f87db737b0.svg";
export { ForwardRef as ReactComponent };